import React from "react";
import { View, Text, TouchableOpacity, Image, StyleSheet } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import Avatar from "../choose-avatar-components/Avatar";

type UserItemProps = {
  user: {
    userID: string;
    profilePicture: any;
    isSelected: number;
  };
  onSelect: () => void;
};

const ConnectUserItem: React.FC<UserItemProps> = ({ user, onSelect }) => {
  return (
    <TouchableOpacity onPress={onSelect} style={styles.container}>
      <View style={styles.profilePicture}>
        <Avatar src={user.profilePicture} variant="pastSmallPlayer" />
      </View>
      <View style={styles.userInfo}>
        <Text style={[AppFontStyle.BOLD_ANYBODY_14, styles.userID]}>
          {user.userID}
        </Text>
      </View>
      <TouchableOpacity disabled style={styles.checkIcon}>
        <Image
          source={
            user.isSelected === 1
              ? AppImages.icnChecked
              : AppImages.icnUnChecked
          }
          style={styles.icon}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    paddingTop: 10,
    gap: 10,
  },
  profilePicture: {
    width: 42,
    height: 42,
    borderRadius: 100,
  },
  userInfo: {
    flex: 1,
    flexDirection: "row",
    alignContent: "space-between",
    gap: 10,
    alignItems: "center",
  },
  userID: {
    paddingBottom: 5,
  },
  helloText: {
    opacity: 0.5,
  },
  checkIcon: {
    height: "100%",
    width: 50,
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    height: 20,
    width: 20,
    alignSelf: "center",
  },
});

export default withErrorBoundary(ConnectUserItem);
